import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const getFeedbackSummary = createAsyncThunk(
  "feedback/getFeedbackSummary",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.get(`feedback/${id}/summary`);
      return response.data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

const FeedbackSummarySlice = createSlice({
  name: "FeedbackSummarySlice",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },
  reducers: {
    resetFeedbackSummary: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFeedbackSummary.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFeedbackSummary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data;
      })
      .addCase(getFeedbackSummary.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetFeedbackSummary } = FeedbackSummarySlice.actions;
export default FeedbackSummarySlice.reducer;
